/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PresentingConcernSectionDto } from './PresentingConcernSectionDto';
import {
    PresentingConcernSectionDtoFromJSON,
    PresentingConcernSectionDtoFromJSONTyped,
    PresentingConcernSectionDtoToJSON,
    PresentingConcernSectionDtoToJSONTyped,
} from './PresentingConcernSectionDto';

/**
 * 
 * @export
 * @interface PresentingConcernsUpsertRequestDto
 */
export interface PresentingConcernsUpsertRequestDto {
    /**
     * Array of presenting concern sections (max 3)
     * @type {Array<PresentingConcernSectionDto>}
     * @memberof PresentingConcernsUpsertRequestDto
     */
    presentingConcerns?: Array<PresentingConcernSectionDto>;
    /**
     * Indicates if this update is part of onboarding flow
     * @type {boolean}
     * @memberof PresentingConcernsUpsertRequestDto
     */
    isOnboarding?: boolean;
}

/**
 * Check if a given object implements the PresentingConcernsUpsertRequestDto interface.
 */
export function instanceOfPresentingConcernsUpsertRequestDto(value: object): value is PresentingConcernsUpsertRequestDto {
    return true;
}

export function PresentingConcernsUpsertRequestDtoFromJSON(json: any): PresentingConcernsUpsertRequestDto {
    return PresentingConcernsUpsertRequestDtoFromJSONTyped(json, false);
}

export function PresentingConcernsUpsertRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PresentingConcernsUpsertRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'presentingConcerns': json['presentingConcerns'] == null ? undefined : ((json['presentingConcerns'] as Array<any>).map(PresentingConcernSectionDtoFromJSON)),
        'isOnboarding': json['isOnboarding'] == null ? undefined : json['isOnboarding'],
    };
}

export function PresentingConcernsUpsertRequestDtoToJSON(json: any): PresentingConcernsUpsertRequestDto {
    return PresentingConcernsUpsertRequestDtoToJSONTyped(json, false);
}

export function PresentingConcernsUpsertRequestDtoToJSONTyped(value?: PresentingConcernsUpsertRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'presentingConcerns': value['presentingConcerns'] == null ? undefined : ((value['presentingConcerns'] as Array<any>).map(PresentingConcernSectionDtoToJSON)),
        'isOnboarding': value['isOnboarding'],
    };
}

